import React, { useState, useEffect } from "react";
import styles from "../Pages/Admin.module.css";

const BASE_URL = "https://portfolio-backend-mauve-five.vercel.app";

function Admin() {
  /* ---------------------- LOGIN STATE ---------------------- */
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loginData, setLoginData] = useState({ username: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();

    if (loginData.username === "Abinesh" && loginData.password === "changeme") {
      setIsLoggedIn(true);
    } else {
      alert("Invalid username or password");
    }
  };

  /* ---------------------- STATES ---------------------- */
  const [blog, setBlog] = useState({ title: "", content: "", image: null });
  const [blogs, setBlogs] = useState([]);
  const [editingBlogId, setEditingBlogId] = useState(null);

  const [project, setProject] = useState({
    name: "",
    description: "",
    image: null,
    link: ""
  });
  const [projects, setProjects] = useState([]);
  const [editingProjectId, setEditingProjectId] = useState(null);

  const [expandedItems, setExpandedItems] = useState({});
  const [popup, setPopup] = useState({ show: false, type: "", id: null });

  /* ---------------------- FETCH DATA ---------------------- */
  const fetchBlogs = async () => {
    try {
      const res = await fetch(`${BASE_URL}/api/blogs`);
      const data = await res.json();
      setBlogs(data);
    } catch (err) {
      console.error("❌ Error fetching blogs:", err);
    }
  };

  const fetchProjects = async () => {
    try {
      const res = await fetch(`${BASE_URL}/api/projects`);
      const data = await res.json();
      setProjects(data);
    } catch (err) {
      console.error("❌ Error fetching projects:", err);
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      fetchBlogs();
      fetchProjects();
    }
  }, [isLoggedIn]);

  /* ---------------------- HANDLERS ---------------------- */
  const handleBlogChange = (e) => {
    setBlog({ ...blog, [e.target.name]: e.target.value });
  };
  const handleProjectChange = (e) => {
    setProject({ ...project, [e.target.name]: e.target.value });
  };
  const handleBlogImage = (e) => {
    setBlog({ ...blog, image: e.target.files[0] });
  };
  const handleProjectImage = (e) => {
    setProject({ ...project, image: e.target.files[0] });
  };

  /* ---------------------- BLOG SUBMIT ---------------------- */
  const handleBlogSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", blog.title);
    formData.append("content", blog.content);
    if (blog.image) formData.append("image", blog.image);

    const url = editingBlogId
      ? `${BASE_URL}/api/blogs/${editingBlogId}`
      : `${BASE_URL}/api/blogs`;

    const method = editingBlogId ? "PUT" : "POST";

    try {
      const res = await fetch(url, { method, body: formData });
      if (!res.ok) throw new Error("❌ Blog saving failed");

      setBlog({ title: "", content: "", image: null });
      setEditingBlogId(null);
      fetchBlogs();
    } catch (err) {
      alert(err.message);
    }
  };

  /* ---------------------- PROJECT SUBMIT ---------------------- */
  const handleProjectSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("name", project.name);
    formData.append("description", project.description);
    formData.append("link", project.link);
    if (project.image) formData.append("image", project.image);

    const url = editingProjectId
      ? `${BASE_URL}/api/projects/${editingProjectId}`
      : `${BASE_URL}/api/projects`;

    const method = editingProjectId ? "PUT" : "POST";

    try {
      const res = await fetch(url, { method, body: formData });
      if (!res.ok) throw new Error("❌ Project saving failed");

      setProject({ name: "", description: "", image: null, link: "" });
      setEditingProjectId(null);
      fetchProjects();
    } catch (err) {
      alert(err.message);
    }
  };

  /* ---------------------- DELETE CONFIRM ---------------------- */
  const handleDelete = async () => {
    try {
      const url =
        popup.type === "blog"
          ? `${BASE_URL}/api/blogs/${popup.id}`
          : `${BASE_URL}/api/projects/${popup.id}`;

      const res = await fetch(url, { method: "DELETE" });
      if (!res.ok) throw new Error("❌ Delete failed");

      popup.type === "blog" ? fetchBlogs() : fetchProjects();

      setPopup({ show: false, type: "", id: null });
    } catch (err) {
      alert(err.message);
    }
  };

  /* ---------------------- UI HELPERS ---------------------- */
  const editBlog = (b) => {
    setBlog({ title: b.title, content: b.content, image: b.image });
    setEditingBlogId(b._id);
  };

  const editProject = (p) => {
    setProject({
      name: p.name,
      description: p.description,
      image: null,
      link: p.link,
    });
    setEditingProjectId(p._id);
  };

  const toggleExpand = (id) => {
    setExpandedItems((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const truncateText = (text, id, limit = 100) => {
    if (expandedItems[id]) return text;
    return text.length <= limit ? text : text.slice(0, limit) + "...";
  };

  /* ---------------------- SIMPLE LOGIN UI ---------------------- */
  if (!isLoggedIn) {
    return (
      <div className={styles.loginPage}>
        <div className={styles.loginBox}>
          <h2>Admin Login</h2>
          <form onSubmit={handleLogin}>
            <div className={styles.inputfld}>
              {/* USERNAME */}
              <input
                type="text"
                placeholder="Username"
                value={loginData.username}
                onChange={(e) =>
                  setLoginData({ ...loginData, username: e.target.value })
                }
                required
              />

              {/* PASSWORD WITH EYE ICON */}
              <div className={styles.passwordWrapper}>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={loginData.password}
                  onChange={(e) =>
                    setLoginData({ ...loginData, password: e.target.value })
                  }
                  required
                />

                <span
                  className={styles.eyeIcon}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? "😀" : "😪"}
                </span>
              </div>
            </div>

            <button type="submit">Login</button>
          </form>
        </div>
      </div>
    );
  }

  /* ---------------------- AFTER LOGIN => ADMIN PANEL ---------------------- */
  return (
    <div className={styles.adminContainer}>
      {/* BLOG FORM */}
      <div className={styles.formSection}>
        <h2>Blogs</h2>
        <form onSubmit={handleBlogSubmit}>
          <input type="text" name="title" value={blog.title} onChange={handleBlogChange} placeholder="Title" required />
          <textarea name="content" value={blog.content} onChange={handleBlogChange} placeholder="Content" required />
          <input type="file" onChange={handleBlogImage} accept="image/*" />
          <button type="submit">{editingBlogId ? "Update Blog" : "Add Blog"}</button>
        </form>

        {/* PROJECT FORM */}
        <h2>Projects</h2>
        <form onSubmit={handleProjectSubmit}>
          <input type="text" name="name" value={project.name} onChange={handleProjectChange} placeholder="Project Name" required />
          <textarea name="description" value={project.description} onChange={handleProjectChange} placeholder="Description" required />
          <input type="text" name="link" value={project.link} onChange={handleProjectChange} placeholder="Project Link" />
          <input type="file" onChange={handleProjectImage} accept="image/*" />
          <button type="submit">{editingProjectId ? "Update Project" : "Add Project"}</button>
        </form>
      </div>

      {/* BLOG LIST */}
      <div className={styles.listSection}>
        <h2>Blogs</h2>
        <div className={styles.cardGrid}>
          {blogs.map((b) => (
            <div key={b._id} className={styles.card}>
              {b.image && <img src={b.image} alt={b.title} />}
              <h3>{b.title}</h3>
              <p>{truncateText(b.content, b._id)}</p>

              {b.content.length > 100 && (
                <button onClick={() => toggleExpand(b._id)} className={styles.readMoreBtn}>
                  {expandedItems[b._id] ? "Show Less" : "Read More"}
                </button>
              )}

              <div className={styles.cardActions}>
                <button onClick={() => editBlog(b)}>Edit</button>
                <button onClick={() => setPopup({ show: true, type: "blog", id: b._id })}>
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* PROJECT LIST */}
        <h2>Projects</h2>
        <div className={styles.cardGrid}>
          {projects.map((p) => (
            <div key={p._id} className={styles.card}>
              {p.image && <img src={p.image} alt={p.name} />}
              <h3>{p.name}</h3>
              <p>{truncateText(p.description, p._id)}</p>

              {p.description.length > 100 && (
                <button onClick={() => toggleExpand(p._id)} className={styles.readMoreBtn}>
                  {expandedItems[p._id] ? "Show Less" : "Read More"}
                </button>
              )}

              {p.link && (
                <a href={p.link} target="_blank" rel="noreferrer">
                  Visit
                </a>
              )}

              <div className={styles.cardActions}>
                <button onClick={() => editProject(p)}>Edit</button>
                <button onClick={() => setPopup({ show: true, type: "project", id: p._id })}>
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* DELETE POPUP */}
      {popup.show && (
        <div className={styles.popupOverlay}>
          <div className={styles.popup}>
            <p>Are you sure you want to delete this {popup.type}?</p>
            <div className={styles.popupActions}>
              <button onClick={handleDelete}>Yes</button>
              <button onClick={() => setPopup({ show: false, type: "", id: null })}>
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Admin;